import { call, put, takeLatest, delay, select } from "redux-saga/effects"
import { authHeader } from "../helpers/auth-header"
import { documentsService } from "../services/documents.services"
import { buildContentService } from "../services/build_content.services"
import { clearMultibase } from "../actions/multiAiBase"
import axiosClient from "axios"
import axios from "../services/axios"
import {
	loadDocumentsOfConceptWithDocsClear,
	loadDocumentsOfConceptWithDocsFailed,
	requestSavedBuildConcepts,
	saveConceptFailed,
	saveConceptSuccess,
	setPsearchApiCall,
	setSelectedBuildConcept,
} from "../actions/buildconceptActions"
import { history } from "../helpers/history"
import { buildQueryString, clearLocalStorage, payloadParsing, reSortArray } from "../utils"
import { hideAlert, showAlertAction } from "../actions/alertActions"

import Swal from "sweetalert2"

import {
	REQUEST_SEARCH_FOR_TOPIC_API,
	TOPICBUILDER_SEARCHING,
	TOPICBUILDER_SAVE_CURRENT_SEARCH,
	TOPICBUILDER_SEARCH_SUCCESS,
	BUILD_CONCEPT_SEARCHING_DOCS,
	BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
	LOGOUT,
	SHOW_ALERT,
	TOPICBUILDER_SEARCH_ERROR,
	BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
	REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT,
	BUILD_CONCEPT_SET_SOURCE_FILTER,
	BUILD_CONCEPT_FIND_DOCUMENTS,
	HIDE_ALERT,
	REQUEST_SAVE_CONCEPT,
	BUILD_CONCEPT_UNSAVED,
	BULD_CONCEPT_LOADING_END,
	BUILD_CONCEPT_SAVE_CURRENT_UUID,
	JOB_STATUS_SUCCESS,
	JOB_STATUS_PENDING,
	BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS_NEW_API,
	BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
	REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS,
	BUILD_CONCEPT_IS_LOADING_DOCS,
	SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS,
	REMOVE_CONCEPT,
	GET_SAVED_BUILD_CONCEPT_ON_API,
	UPDATE_LAST_CONCEPTS_CALL,
	SAVED_SEARCH_LOAD_ALL,
	SET_CURRENT_FILTER,
	BUILD_CONCEPT_CURRENT_FILTER_CHANGE,
} from "../types/index"
import { CLIENT_SIDE_MESSAGES as Messages } from "../utils"
import { logoutUser } from "../actions/userActions"
import { setNotification } from "../actions/notificationActions"
import { setFilterJobId } from "../actions/filterActions"

// function* requestDocumentsList(value) {
//     yield put ({
//         type: BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
//         payload: value
//     });

//     yield put ({
//         type:BUILD_CONCEPT_SEARCHING_DOCS,
//         payload:value
//     });
// }

const getTopicByJobId = async (id) => {
	return await axios.get(`/p_topic/${id}`).catch((e) => console.log(e))
}

const getJobByJobId = async (id) => {
	return await axios
		.get(`/job/${id}`, {
			cancelToken: source.token,
		})
		.catch((e) => {
			throw new Error(e?.message)
		})
}

const getStatusByJobId = async (id) => {
	return await axios.get(`/job/${id}`).catch((e) => console.log(e))
}
const setDocCount = async (concept_id) => {
	return await axios.post(`/concept/set_doccount/${concept_id}`).catch((e) => console.log(e))
}

const getPsearchStatusByJobId = async (id) => {
	return await axios.get(`/p_search/${id}`)
}

const source = axiosClient.CancelToken.source()

function* buildConceptUpdateDocumentsFlow(action) {
	const state = yield select()
	const currentNeg = state.buildconcept.currentFilter.neg_phrase_count
	var negativeItems = document.getElementsByClassName("negative_term")
	//Modify the list of terms searching for
	const sortTopicResult = action.payload.terms.map((item, index) => {
		return [item, action.payload.relatedness[index]]
	})
	let positiveSearch = sortTopicResult.filter((i) => i[1] >= 0).map((i) => i[0])
	let negativeSearch = sortTopicResult
		.filter((i) => i[1] < 0)
		.slice(0, currentNeg)
		.map((i) => i[0])
	//dispatch(setHighlightConcepts({positive: positiveSearch, negative: negativeSearch}));
	yield put({
		type: BUILD_CONCEPT_LIST_HIGHLIGHT_CONCEPTS,
		payload: { positive: positiveSearch, negative: negativeSearch },
	})
}

function* saveConceptFlow(action) {
	yield put({
		type: TOPICBUILDER_SEARCHING,
		payload: true,
	})
	let response = null
	try {
		response = yield call(buildContentService.conceptSave, action.new_concept)
		if (response.data.success === true) {
			yield put(saveConceptSuccess())
			yield put({
				type: SHOW_ALERT,
				payload: {
					msg: "Concept saved",
					class: "alert alert-dismissible alert-success",
				},
			})
			yield put({
				type: BUILD_CONCEPT_UNSAVED,
				payload: false,
			})
			//dispatch(getSavedBuildConceptsOnAPI(true));
			yield put({
				type: BULD_CONCEPT_LOADING_END,
				payload: false,
			})
			yield put({
				type: BUILD_CONCEPT_SAVE_CURRENT_UUID,
				payload: response.data.concept.id,
			})

			yield put(setSelectedBuildConcept(response.data.concept))
			const countResponse = yield call(setDocCount, response.data.concept.id)
			if (countResponse.data.success === true) yield put(requestSavedBuildConcepts(true))
			yield delay(5000)
			yield put({
				type: HIDE_ALERT,
				payload: null,
			})
			// const state = yield select();
			// let alertMsg = state.alert.alert.msg;
			// if (alertMsg==='Concept saved'){
			//     yield put ({
			//         type: HIDE_ALERT,
			//         payload: null
			//     })
			// }
		} else {
			yield put(saveConceptFailed())
			yield put(
				setNotification({
					data: response?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
				})
			)
			yield put({
				type: BULD_CONCEPT_LOADING_END,
				payload: false,
			})
		}
	} catch (error) {
		console.log(error)
		try {
			if (error?.response?.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		yield put({
			type: TOPICBUILDER_SEARCH_ERROR,
			payload: true,
		})
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
		yield put(saveConceptFailed())
	}
}

function* searchForTopicAPIFlow(action) {
	const { ignore_terms, soft_ignore, soft_target, target_terms } = action.payload
	try {
		if (ignore_terms.length === 0 && soft_ignore.length === 0 && soft_ignore.length === 0 && target_terms.length === 0) {
			return
		}
	} catch (e) {
		console.log(e)
		return
	}
	// dispatch(requestConceptAPI());
	yield put({
		type: TOPICBUILDER_SEARCHING,
		payload: true,
	})
	// dispatch(saveCurrentItem(topic));
	yield put({
		type: TOPICBUILDER_SAVE_CURRENT_SEARCH,
		payload: action.payload,
	})
	try {
		//Get from API
		// const response = await buildContentService.topicBuilder(topic);
		const jobId = yield call(buildContentService.topicBuilder, action.payload)
		let topicJobId = yield call(getJobByJobId, jobId.data.job_id)
		yield put({
			type: BUILD_CONCEPT_SEARCHING_DOCS,
			payload: true,
		})
		while (
			(topicJobId?.data && topicJobId?.data?.job?.job_status?.success === false) ||
			topicJobId?.data?.job?.job_status?.is_finished === false
		) {
			console.log("esperando al job")
			console.log(topicJobId.data.job.job_status.success)
			yield delay(1000)
			topicJobId = yield call(getJobByJobId, jobId.data.job_id)
		}

		if (topicJobId?.data && topicJobId.data.job.job_status.success === true) {
			yield put({
				type: JOB_STATUS_SUCCESS,
				payload: {
					jobId: jobId.data.job_id,
					status: topicJobId.data.job.job_status.success,
					location: action.payload.location,
				},
			})

			const response = yield call(getTopicByJobId, topicJobId.data.job.job_id)
			// dispatch(requestConceptAPISuccess({"data": response.data.data, "topic":topic}));
			if (response?.data) {
				yield put({
					type: BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS_NEW_API,
					payload: response.data.data,
				})
				yield put({
					type: TOPICBUILDER_SEARCH_SUCCESS,
					payload: { data: response.data.data, topic: action.payload },
				})
				if (response?.data?.data?.count?.length) {
					yield put(setPsearchApiCall())
				} else {
					yield put(loadDocumentsOfConceptWithDocsClear())
				}
			}
		} else {
			yield put({
				type: JOB_STATUS_PENDING,
				payload: {
					jobId: jobId?.data?.job_id,
					status: topicJobId?.data?.job?.job_status?.success,
					location: action?.payload?.location,
				},
			})
			if (!topicJobId) {
				yield put(
					setNotification({
						data: error?.response || "something went wrong",
						severity: "error",
					})
				)
			}
		}
		// setTimeout(function(){dispatch(requestDocumentsList(true))},100);
		yield delay(100)
		// requestDocumentsList(true);
		/*yield put ({
            type: BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
            payload: true
        });
        */

		// dispatch(setCurrentSearchingDocs(true));
		// yield put ({
		//     type:BUILD_CONCEPT_SEARCHING_DOCS,
		//     payload: true
		// })
		// dispatch(setForceCloudRefresh(true));
		yield put({
			type: BUILD_CONCEPT_FORCE_CLOUD_REFRESH,
			payload: true,
		})
		yield put({
			type: TOPICBUILDER_SEARCHING,
			payload: false,
		})
		//Search for doc_count
	} catch (error) {
		yield put({
			type: TOPICBUILDER_SEARCHING,
			payload: false,
		})
		try {
			if (axiosClient.isCancel(error)) {
				return
			}
			if (error?.response?.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(requestConceptAPIError(true));
		yield put({
			type: TOPICBUILDER_SEARCH_ERROR,
			payload: true,
		})
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		// yield put({
		// 	type: SHOW_ALERT,
		// 	payload: alert,
		// })
		yield put(
			setNotification({
				data: error?.message || "something went wrong",
				severity: "error",
			})
		)
	}
}

function* loadDocumentsOfConceptWithDocsFlow(action) {
	try {
		yield put({
			type: BUILD_CONCEPT_IS_LOADING_DOCS,
			payload: true,
		})
		let response = null
		const payload = payloadParsing(action.payload?.params) //new payload conversion
		response = yield call(documentsService.getDocuments, payload)

		// if (!action?.payload?.jobIdToRetainData) {
		// 	response = yield call(documentsService.getDocuments, action.payload?.params)
		// } else response = { data: { success: true, job_id: action?.payload?.jobIdToRetainData } }

		if (response?.data?.success) {
			const queryString = buildQueryString(action.payload?.params) //for querystring use old payload
			const url = `${window.location.pathname}?${queryString}`
			history.push(url)

			const ids = response.data.data.map((item) => item.file_id)

			let contextId, context
			if (action.payload?.additional_params?.review_id) {
				contextId = action.payload?.additional_params?.review_id
				context = CONTEXT_TYPE.REVIEW
			} else if (action.payload?.additional_params?.search_id) {
				contextId = action.payload?.additional_params?.search_id
				context = CONTEXT_TYPE?.SEARCH
			}

			const metadata = yield call(documentsService.getFilesMetadata, ids, contextId, context)

			if (metadata?.data?.data?.length) {
				yield put({
					type: BUILD_CONCEPT_FIND_DOCUMENTS,
					payload: { data: [...metadata?.data?.data], count: response?.data?.count },
				})
			} else {
				yield put({
					type: BUILD_CONCEPT_IS_LOADING_DOCS,
					payload: false,
				})
				yield put({
					type: BUILD_CONCEPT_FIND_DOCUMENTS,
					payload: { data: [], count: 0 },
				})
			}

			// if (response) yield put(setFilterJobId(response?.data?.job_id))
			// let jobId = yield call(getStatusByJobId, response.data.job_id)

			// while ((jobId?.data && jobId.data.job.job_status.success === false) || jobId.data.job.job_status.is_finished === false) {
			// 	yield delay(1000)
			// 	jobId = yield call(getStatusByJobId, response.data.job_id)
			// }

			// if (jobId?.data && jobId.data.job.job_status.success === true) {
			// 	const concept = yield call(getPsearchStatusByJobId, response.data.job_id)
			// 	const count = concept.data.data.count || 0

			// 	const docIdArray = []
			// 	for (var i = 0; i < concept.data.data.data.length; i++) {
			// 		docIdArray.push(`${concept.data.data.data[i].id}`)
			// 	}

			// 	const allDocuments = yield call(documentsService.getFilesMetadata, docIdArray)

			// 	yield put({
			// 		type: BUILD_CONCEPT_FIND_DOCUMENTS,
			// 		payload: { data: [...allDocuments.data.data], count: count },
			// 	})
			//yield put(getAllDocumentsRequestSuccess({ data: { ...allDocuments.data }, count: count })) //To do: update when count is returned in the response
			//}
		} else {
			//yield put(loadDocumentsOfConceptWithDocsFailed(response.message))
			//yield delay(3000) //After 3sec message disappear
			//yield put(loadDocumentsOfConceptWithDocsClear())
			yield put(
				setNotification({
					data: response?.data || "something went wrong",
					severity: "error",
				})
			)
		}
		yield put({
			type: BUILD_CONCEPT_IS_LOADING_DOCS,
			payload: false,
		})
	} catch (error) {
		yield put({
			type: BUILD_CONCEPT_IS_LOADING_DOCS,
			payload: false,
		})
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error?.response?.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}
				//yield put(loadDocumentsOfConceptWithDocsFailed(Messages.SERVER_ERROR))
				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				//yield put(showAlertAction(alert))
				//yield delay(3000) //After 3sec message disappear
				//yield put(yield put(loadDocumentsOfConceptWithDocsClear()))
				//yield put(hideAlert())
				yield put(
					setNotification({
						data: error?.response || "something went wrong",
						severity: "error",
					})
				)
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* loadDocumentsOfConceptFlow(action) {
	const state = yield select()
	const { positive_terms, negative_terms, filtersObject, cancelToken } = action.payload
	try {
		let sourceApi = state.sources.docs_sources
		//Get from API
		// dispatch(setCurrentSourceFilter(filtersObject));
		yield put({
			type: BUILD_CONCEPT_SET_SOURCE_FILTER,
			payload: filtersObject,
		})
		// const response = await documentsService.toolsSearch(positive_terms, negative_terms, filtersObject, [], true, 0, cancelToken, sourceApi);
		const response = yield call(
			documentsService.toolsSearch,
			positive_terms,
			negative_terms,
			filtersObject,
			[],
			true,
			0,
			cancelToken,
			sourceApi
		)
		if (Object.keys(response.data).length === 2) {
			let auxData = response.data
			if (Array.isArray(response.data.count)) {
				auxData.count = auxData.count[0].myCount
			}
			// dispatch(saveConceptDocs(auxData));
			yield put({
				type: BUILD_CONCEPT_FIND_DOCUMENTS,
				payload: auxData,
			})
			// dispatch(requestDocumentsList(false));
			yield put({
				type: BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS,
				payload: false,
			})
			yield put({
				type: BUILD_CONCEPT_SEARCHING_DOCS,
				payload: false,
			})
			// dispatch(setCurrentSearchingDocs(false));
			// yield put ({
			//     type:BUILD_CONCEPT_SEARCHING_DOCS,
			//     payload: false
			// })
		}
		// dispatch(alertActions.hideAlertAction());
		yield put({
			type: HIDE_ALERT,
			payload: null,
		})

		//dispatch(setForceCloudRefresh(true));
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
				//console.log('Request canceled', error.message);
				return
			}
			if (error?.response?.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(requestConceptAPIError(true));
		yield put({
			type: TOPICBUILDER_SEARCH_ERROR,
			payload: true,
		})
		//  dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));

		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		// yield put({
		// 	type: SHOW_ALERT,
		// 	payload: alert,
		// })
		// yield delay(3000) //After 3sec message disappear
		// yield put(hideAlert())
		yield put(
			setNotification({
				data: error?.response || "something went wrong",
				severity: "error",
			})
		)
	}
}

function* removeConceptFlow(action) {
	const state = yield select()
	const { ext_id, showSwal } = action.payload
	try {
		// const response = await buildContentService.removeConceptAPI(ext_id);
		const response = yield call(buildContentService.removeConceptAPI, ext_id)
		if (response.data.success === true) {
			const allConcepts = state.buildconcept.user_saved_build_concepts
			const newAllConcepts = allConcepts.filter((item) => item.id !== ext_id)
			// dispatch(setUserListBuildConcepts(newAllConcepts));
			yield put({
				type: SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS,
				payload: newAllConcepts,
			})

			if (showSwal === true) {
				Swal.fire("Deleted!", "Your file has been deleted.", "success")
			}
		} else {
			//  dispatch(alertActions.showAlertAction({
			//     msg: 'There was an error. Please, try again and check your connection',
			//     class: 'alert alert-danger'
			// }));
			let alert = {
				msg: "There was an error. Please, try again and check your connection",
				class: "alert alert-danger",
			}
			yield put({
				type: SHOW_ALERT,
				payload: alert,
			})
		}
	} catch (error) {
		try {
			if (error?.response?.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(requestConceptAPIError(true));
		yield put({
			type: TOPICBUILDER_SEARCH_ERROR,
			payload: true,
		})
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* getSavedBuildConceptsOnAPIFlow(action) {
	const state = yield select()
	const { force } = action.payload
	// dispatch(requestConceptAPI());
	yield put({
		type: TOPICBUILDER_SEARCHING,
		payload: true,
	})
	try {
		let header = authHeader()
		if (header.hasOwnProperty("auth_token") === false) {
			// setTimeout(function(){dispatch(getSavedBuildConceptsOnAPI());},1000);
			yield delay(1000)
			yield put({
				type: GET_SAVED_BUILD_CONCEPT_ON_API,
				payload: {
					force: force,
				},
			})

			return
		}
		const lastCall = state.buildconcept.last_concepts_saved_request
		//1 minutes = 300000 millisecons
		if (lastCall === null || new Date().getTime() - lastCall > 60000 || force === true) {
			// const response = await buildContentService.conceptList();
			const response = yield call(buildContentService.conceptList)
			// dispatch(setUserListBuildConcepts(response.data.data));
			yield put({
				type: SAVED_BUILD_CONCEPTS_SEARCHING_SUCCESS,
				payload: response.data.data,
			})
			//Aqui guardo la fecha de la última vez que se ha recibido si todo ok
			if (response.data.data.length > 0) {
				// dispatch(setLastConceptSavedReq());
				yield put({
					type: UPDATE_LAST_CONCEPTS_CALL,
				})
			}
			// dispatch(savedSearchLoadAll());
			yield put({
				type: SAVED_SEARCH_LOAD_ALL,
			})
		}
		// dispatch(loadingEnd());
		yield put({
			type: BULD_CONCEPT_LOADING_END,
			payload: false,
		})
	} catch (error) {
		try {
			if (error?.response?.status === 403) {
				clearLocalStorage()
				yield put(clearMultibase())
				// dispatch(errorUser());
				yield put({
					type: LOGOUT,
					payload: null,
				})
				return
			}
		} catch (e) {}
		// dispatch(requestConceptAPIError(true));
		yield put({
			type: TOPICBUILDER_SEARCH_ERROR,
			payload: true,
		})
		// dispatch(alertActions.showAlertAction({
		//     msg: 'There was an error. Please, try again and check your connection',
		//     class: 'alert alert-danger'
		// }));
		let alert = {
			msg: "There was an error. Please, try again and check your connection",
			class: "alert alert-danger",
		}
		yield put({
			type: SHOW_ALERT,
			payload: alert,
		})
	}
}

function* setCurrentFilterFlow(action) {
	const { filter } = action.payload
	// return new Promise((resolve, reject) => {
	//     dispatch(updateFilterValues(filter));
	//     resolve();
	// })
	return Promise.resolve(
		yield put({
			type: BUILD_CONCEPT_CURRENT_FILTER_CHANGE,
			payload: filter,
		})
	)
}

// Watches for the UPDATEACCOUNTDETAILS_REQUESTING action type
// When it gets it, it will call verificarFlow()
// WITH the action we dispatched
function* buildWatcher() {
	// takeLatest() takes the LATEST call of that action and runs it
	// if we we're to use takeEvery, it would take every single
	// one of the actions and kick off a new task to handle it
	// CONCURRENTLY!!!
	yield takeLatest(REQUEST_SEARCH_FOR_TOPIC_API, searchForTopicAPIFlow)
	yield takeLatest(REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT, loadDocumentsOfConceptFlow)
	yield takeLatest(REQUEST_BUILD_LOAD_DOCUMENTS_OF_CONCEPT_WITH_DOCS, loadDocumentsOfConceptWithDocsFlow)
	yield takeLatest(REQUEST_SAVE_CONCEPT, saveConceptFlow)
	//TOPICBUILDER_SEARCH_SUCCESS to detect when the build concepts make a search to get the docs of the search
	yield takeLatest(BUILD_CONCEPT_NEED_TO_REFESH_DOCUMENTS_NEW_API, buildConceptUpdateDocumentsFlow)
	yield takeLatest(REMOVE_CONCEPT, removeConceptFlow)
	yield takeLatest(GET_SAVED_BUILD_CONCEPT_ON_API, getSavedBuildConceptsOnAPIFlow)
	yield takeLatest(SET_CURRENT_FILTER, setCurrentFilterFlow)
}

export default buildWatcher
